import axios from "@main/axios";
import {MODAL_AUTO_CLOSE_TIMEOUT, TEST_OFFSET_SCROLL, INPUT_TIMEOUT} from "@main/constants";

export class Testing {
    constructor(el) {
        this.el = el;
        this.action = this.el.getAttribute("action") || this.el.dataset.action;
        this.allowEmpty = this.el.dataset.allowEmpty || false;
        this.noScroll = this.el.dataset.noScroll || false;
        this.endTime = Number(this.el.dataset.endTime);
        this.inputCurrent = this.el.querySelector(".js-test-current");
        this.inputAction = this.el.querySelector(".js-test-action");
        this.items = [...this.el.querySelectorAll(".js-test-item")];
        this.radio = [...this.el.querySelectorAll(".js-test-radio")];
        this.textInputs = [...this.el.querySelectorAll(".js-test-text")];
        this.checkbox = [...this.el.querySelectorAll(".js-test-checkbox")];
        this.finishBtn = this.el.querySelector(".js-test-finish");
        this.skippedText = document.querySelector(".js-skipped-text");
        this.skippedModal = document.querySelector(".js-skipped-modal");
        this.timeupModal = document.querySelector(".js-test-timeup-modal");
        this.resultModal = document.querySelector(".js-test-result-modal");
        this.resultModalText = document.querySelector(".js-test-result-modal-text");
        this.resultModalTitle = document.querySelector(".js-test-result-modal-title");
        this.scrollToSkippedBtn = document.querySelectorAll(".js-scroll-to-skipped");
        this.finish = false;
        this.skipped = [];
        this.timerId = null;
        this.timerIdInput = null;
        this.initEvents();
        this.initTimer();
    }

    initEvents() {
        const currentSlideIndex = this.getCurrentSlideIndex();

        if (currentSlideIndex) {
            this.scrollToItem(currentSlideIndex);
        }

        this.radio.forEach((radio) => {
            radio.addEventListener("change", () => {
                this.sendRadioValue(radio);
            });
        });

        this.checkbox.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                this.sendCheckboxValue(checkbox);
            });
        });

        this.textInputs.forEach((input) => {
            input.addEventListener("input", () => {
                clearTimeout(this.timerIdInput);
                this.timerIdInput = setTimeout(() => {
                    this.sendTextValue(input);
                }, INPUT_TIMEOUT);
            });
        });

        this.finishBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.finish = true;
            this.setAction();
            const formData = new FormData(this.el);
            this.sendData(formData);
            return false;
        });

        if (this.scrollToSkippedBtn.length) {
            this.scrollToSkippedBtn.forEach((btn) => {
                btn.addEventListener("click", () => {
                    if (this.skipped.length) {
                        this.scrollToItem(this.skipped[0] - 1);
                    }
                });
            });
        }
    }

    sendRadioValue(radio) {
        this.finish = false;
        let needScroll = false;
        this.setAction();
        const formData = new FormData();
        const item = this.getParentItem(radio);
        if (radio.closest(".js-test-radio-group")) {
            const values = this.radio
                .filter((other) => other.checked && other.dataset.name === radio.dataset.name)
                .map((other) => other.value);
            formData.append(radio.dataset.name, values);
            needScroll = this.allRadioGroupsChecked(item);
        } else {
            formData.append(radio.name, radio.value);
            needScroll = true;
        }
        formData.append("current", item.id);
        formData.append("action", "save");
        this.sendData(formData);
        if (needScroll) {
            item.classList.add("done");
            this.scrollToNext(item);
        }
    }

    allRadioGroupsChecked(item) {
        return item.querySelectorAll(".js-test-radio-group").length === item.querySelectorAll("input[type='radio']:checked").length
    }

    sendCheckboxValue(checkbox) {
        this.finish = false;
        this.setAction();
        const item = this.getParentItem(checkbox);
        const values = this.checkbox
            .filter((other) => other.checked && other.name === checkbox.name)
            .map((other) => other.value);
        const formData = new FormData();
        formData.append(checkbox.dataset.name, values);
        formData.append("current", item.id);
        formData.append("action", "save");
        this.sendData(formData);
        if (values.length) {
            item.classList.add("done");
            this.scrollToNext(item);
        } else {
            item.classList.remove("done");
        }
    }

    sendTextValue(input) {
        this.finish = false;
        const item = this.getParentItem(input);
        this.setAction();
        const formData = new FormData();
        formData.append(input.name, input.value);
        formData.append("current", item.id);
        formData.append("action", "save");
        this.sendData(formData);
        if (input.value) {
            item.classList.add("done");
            this.scrollToNext(item);
        } else {
            item.classList.remove("done");
        }
    }

    initTimer() {
        if (this.endTime > 0) {
            this.timerId = setInterval(() => {
                this.checkTimeup();
            }, 1000);
        }
    }

    getCurrentSlideIndex() {
        if (this.inputCurrent.value) {
            const current = document.getElementById(this.inputCurrent.value);
            if (current) {
                return this.items.indexOf(current);
            }
        }
        return 0;
    }

    scrollToNext(item) {
        if (this.noScroll) {
            return;
        }
        const index = this.items.indexOf(item);
        this.scrollToItem(index + 1);
    }

    scrollToItem(index) {
        if (this.items[index]) {
            window.scrollBy({
                top: this.items[index].getBoundingClientRect().top - TEST_OFFSET_SCROLL,
                behavior: "smooth"
            });
        }
    }

    getParentItem(elem) {
        return elem.closest(".js-test-item");
    }

    sendData = async (formData) => {
        try {
            if (!this.checkAnswers()) {
                return;
            }

            const response = await axios.post(
                this.action,
                formData
            );

            if (this.finish) {
                clearInterval(this.timerId);
                if (!response?.data) {
                    this.showResult("Что-то пошло не так...<br>Пожалуйста, перезагрузите страницу.", "Произошла ошибка", true);
                    return;
                }
                if (response.data.success) {
                    this.finishBtn.remove();
                    this.showResult(response.data.message, response.data.data?.title, false, response.data.data?.successClose, response.data.data?.successUrl);
                } else {
                    this.showResult(response.data.message, response.data.data?.title || "Произошла ошибка", true, false);
                }
            } else {
                if (response.data.data?.timeup) {
                    this.endTime = Date.now();
                    this.checkTimeup();
                }
            }
        } catch (error) {
            this.showResult(error, "Произошла ошибка", true, false);
        }
    }

    setAction() {
        if (this.finish) {
            this.inputAction.value = "finish";
        } else {
            this.inputAction.value = "save";
        }
    }

    checkAnswers() {
        if (!this.finish || this.allowEmpty) {
            return true;
        }
        this.skipped = [];
        this.items.forEach((item, index) => {
            if (item.querySelector(".js-test-radio-group")) {
                if (!this.allRadioGroupsChecked(item)) {
                    this.skipped.push(index + 1);
                }
            } else if (!item.querySelectorAll(".js-test-radio:checked").length && !item.querySelectorAll(".js-test-checkbox:checked").length) {
                this.skipped.push(index + 1);
            }
        });
        if (this.skipped.length) {
            if (this.skippedText) {
                this.skippedText.innerHTML = this.skipped.join(", ") + ".";
            }
            if (this.skippedModal) {
                this.skippedModal.dispatchEvent(new CustomEvent("openModal"));
            }
            return false;
        }
        return true;
    }

    showResult(text, title, error = false, autoClose = false, redirect = "") {
        if (this.resultModal) {
            if (this.resultModalText && text) {
                this.resultModalText.innerHTML = text;
                if (error) {
                    this.resultModalText.classList.add("error");
                } else {
                    this.resultModalText.classList.remove("error");
                }
            }
            if (this.resultModalTitle && title) {
                this.resultModalTitle.innerHTML = title;
            }
            this.resultModal.dispatchEvent(new CustomEvent("openModal"));
            if (autoClose) {
                setTimeout(() => {
                    this.resultModal.dispatchEvent(new CustomEvent("closeModal"));
                }, MODAL_AUTO_CLOSE_TIMEOUT);
            }
            if (redirect) {
                setTimeout(() => {
                    window.location.href = redirect;
                }, MODAL_AUTO_CLOSE_TIMEOUT);
            }
        } else {
            alert(text);
        }
    }

    checkTimeup() {
        if (this.endTime > 0 && Date.now() >= this.endTime) {
            this.timeupModal.dispatchEvent(new CustomEvent("openModal"));
            this.finishBtn.remove();
            clearInterval(this.timerId);
        }
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-test").forEach(elem => new Testing(elem));
}, false);

